import React, { useEffect, useState } from "react";
import axios from "./axios";
import "./Row.css";
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer";

const base_url = "https://image.tmdb.org/t/p/original";
const opts = {
  height: "390",
  width: "640",
  playerVars: {
    // https://developers.google.com/youtube/player_parameters
    autoplay: 1,
    controls: 0,
  },
};

function Row({ title, fetchUrl, isLargeRow }) {
  const [movies, setMovies] = useState([]);
  const [trailerUrl, setTrailerUrl] = useState("");

  //snippet of code which runs based on specific condition/variable
  //For last variable, if [], run once when row loads and never runs again
  //however if [item], everytime item loads/changes, this function runs
  //everytime we use variables that are passed outside of block inside useEffect, its important to be passed in the last variables, example fetchUrl here
  useEffect(() => {
    async function fetchData() {
      // console.log(axios.get(fetchUrl));
      // fetchUrl is added to the default url in axios file while using axios.get
      const request = await axios.get(fetchUrl);
      //use console.log to see the request for me to code later
      // console.log(request);

      setMovies(request.data.results);
      return request;
    }
    fetchData();
  }, [fetchUrl]);

  // console.table(movies);
  const handleClick = (movie) => {
    if (trailerUrl) {
      console.log("here");
      setTrailerUrl("");
    } else {
      console.info("ELSE BLOCK");
      console.info(movie);
      movieTrailer(movie?.title || "")
        .then((url) => {
          // https://www.youtube.com/watch?v=m_u6P5k0vP0
          const urlParams = new URLSearchParams(new URL(url).search);
          console.log("there");
          console.log(urlParams);
          setTrailerUrl(urlParams.get("v"));
        })
        .catch((error) => {
          console.error("ERROR");
          console.log(error);
        });
    }
  };

  return (
    <div className="row">
      {/* title */}
      <h2>{title}</h2>

      {/* posters */}
      <div className="row__posters">
        {/* several row posters */}
        {movies.map((movie) => (
          <img
            key={movie.id}
            onClick={() => handleClick(movie)}
            className={`row__poster ${isLargeRow && "row__posterLarge"}`}
            src={`${base_url}${
              isLargeRow ? movie.poster_path : movie.backdrop_path
            }`}
            alt={movie.name}
          ></img>
        ))}
      </div>
      {trailerUrl && (
        <YouTube className="row__trailer" videoId={trailerUrl} opts={opts} />
      )}
    </div>
  );
}

export default Row;
